import React from "react";
import Sidebar from "./Sidebar";
import TaskContent from "./TaskContent";
import TaskHeader from "./TaskHeader";

export default function TaskBody() {
  return (
    <div className="container relative">
      <Sidebar />
      <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <TaskHeader />
          <TaskContent />
        </main>
      </div>
    </div>
  );
}
